import React from 'react';
import { observer } from 'mobx-react-lite';

import PaymentAPI from 'api/payment_api';
import useStores from 'hooks/useStores';
import { PaymentProps, RefundPaymentType } from 'stores/payment_store';
import { PagedResult } from 'utils/types';

// type PaymentType = {
//     key: string;
//     type: string;
// };


type PaymentContextType = {
    convertTaskToCredits: () => Promise<PaymentProps>;
    supportFetchPayments: (identity: string, userUuid: string, cursor?: string) => Promise<PagedResult<PaymentProps>>;
    supportRefundPayment: (refundType: RefundPaymentType) => Promise<PaymentProps>;
}

export const PaymentContext = React.createContext<PaymentContextType>({
   convertTaskToCredits: () => { throw "Not implemented" },
    supportFetchPayments: () => { throw "Not implemented" },
    supportRefundPayment: () => { throw "Not implemented" },
});

export const PaymentProvider = observer(({ children }: { children: React.ReactNode }) => {
    const { paymentStore } = useStores();
    const convertTaskToCredits = () => {
        return PaymentAPI.convertTaskToCredits();
    };

    const supportFetchPayments = (identity: string, userUuid: string, cursor?: string) => {
        return paymentStore.listForSupport(identity, userUuid, cursor);
    };

const supportRefundPayment = (refundType: RefundPaymentType) => {
    return paymentStore.supportRefundPayment(refundType);
};

    const data = {
        convertTaskToCredits,
        supportFetchPayments,
        supportRefundPayment,
    };

    return (
        <PaymentContext.Provider value={data}>{ children }</PaymentContext.Provider>
    );

});
